export const loginValidation = {
    nameRequired: "Please enter name",
    nameInvalid: "Contain only characters",
    mobileNo: "Please enter mobile no.",
    mobileNoInvalid: "Please enter a valid mobile number",
    passwordRequired: "Please enter password",
    passwordInvalid: "Password must contain more than 8 characters including 1 number, 1 upper case letter, and 1 special character.",
    emailRequired: 'Please enter email',
    emailInvalid: 'Email is Invalid',
    willowIdRequired: 'Please enter willoid',
};


export const regex = {
    // emailRegex: /^[\w.-]+@([\w-]+\.)+[\w-]{2,4}$/,
    passwordRegex: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,32}$/,
    mobilenoRegex: /^\+?[0-9]{10,15}$/,
    // /^\+?[0-9\s\-]{10,20}$/ allow space 
    nameRegex: /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/i,

};